import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import Landing from './pages/Landing'
import Login from './pages/Login'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import CreateLeague from './pages/CreateLeague'
import JoinLeague from './pages/JoinLeague'
import Discover from './pages/Discover'
import LeagueView from './pages/LeagueView'
import Atmosphere from './components/Atmosphere'
import './styles.css'
import { registerServiceWorker } from './lib/pwa'

function Protected({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth()
  if (loading) return <div className="center muted">Loading…</div>
  if (!session) return <Navigate to="/login" replace />
  return <>{children}</>
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      {/* Not Protected: the recovery session arrives from the URL fragment, so
          this page has to render before a session is established. */}
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/new" element={<Protected><CreateLeague /></Protected>} />
      <Route path="/app/join" element={<Protected><JoinLeague /></Protected>} />
      <Route path="/app/discover" element={<Protected><Discover /></Protected>} />
      <Route path="/app/l/:leagueId" element={<Protected><LeagueView /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

registerServiceWorker()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        {/* Outside the router on purpose: the background must not unmount and
            restart its animation every time someone changes page. */}
        <Atmosphere />
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
